import { render, staticRenderFns } from "./CompetitionBrowser.vue?vue&type=template&id=4b7d5fb2"
import script from "./CompetitionBrowser.vue?vue&type=script&lang=js"
export * from "./CompetitionBrowser.vue?vue&type=script&lang=js"
import style0 from "./CompetitionBrowser.vue?vue&type=style&index=0&id=4b7d5fb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports